import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import GenericButton from './GenericButton';
import cookieManager from '../utils/cookieUtils';

const BannerContainer = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: #222;
  color: #fff;
  padding: 1.25rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2000;
  box-shadow: 0 -2px 16px rgba(0,0,0,0.12);
  @media (min-width: 600px) {
    flex-direction: row;
    justify-content: center;
  }
`;

const Message = styled.span`
  font-size: 1rem;
  margin-bottom: 0.75rem;
  text-align: center;
  @media (min-width: 600px) {
    margin-bottom: 0;
    margin-right: 1.5rem;
    text-align: left;
  }
`;

const PRIVACY_NOTICE_COOKIE = 'mpna'; // moria privacy notice accepted

const PrivacyNoticeBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = cookieManager.getCookie(PRIVACY_NOTICE_COOKIE);
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    cookieManager.setPreferenceCookie(PRIVACY_NOTICE_COOKIE, 'true', 365); // 1 year expiration
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <BannerContainer>
        <Message>
          Bu sitenin çalışması için gerekli bazı çerezler kullanılmaktadır: Oturumunuzu ve kimliğinizi yönetmek, sepet ve alışveriş işlemlerini sürdürmek, güvenlik ve kullanıcı tercihlerinizi hatırlamak için çerezler kullanılır.
          Detaylar için gizlilik politikamıza bakabilirsiniz.
        </Message>
        <GenericButton onClick={handleAccept} $fontSize="1rem" $padding="0.75rem 2rem">
          Tamam
        </GenericButton>
    </BannerContainer>
  );
};

export default PrivacyNoticeBanner; 